import React from 'react'
import { KambiLiveData } from '@mobi/api-types/kambi'

export const MatchClock: React.FC<{
  clock: KambiLiveData['matchClock']
  shouldShowPeriod?: boolean
  isCountdown?: boolean
}> = ({ clock, shouldShowPeriod, isCountdown = false }) => {
  return useMatchClockDisplay({
    clock,
    shouldShowPeriod,
    isCountdown,
  })
}

export const useMatchClockDisplay = ({
  clock,
  shouldShowPeriod,
  isCountdown = false,
}: {
  clock: KambiLiveData['matchClock']
  shouldShowPeriod?: boolean
  isCountdown?: boolean
}) => {
  const minute =
    isCountdown && clock.minutesLeftInPeriod !== undefined
      ? clock.minutesLeftInPeriod
      : clock.minute
  const second =
    isCountdown && clock.secondsLeftInMinute !== undefined
      ? clock.secondsLeftInMinute
      : clock.second

  const [display, setDisplay] = React.useState({
    minute,
    second,
  })

  React.useEffect(() => {
    setDisplay({
      minute,
      second,
    })
  }, [minute, second, clock.period])

  React.useEffect(() => {
    if (!clock.running) return

    const interval = setInterval(() => {
      setDisplay(prev => {
        let { minute, second } = prev

        if (isCountdown) {
          if (minute === 0 && second === 0) {
            return prev
          }

          second -= 1
          if (second < 0) {
            second = 59
            minute -= 1
          }
          return { minute, second }
        }
        second += 1
        if (second >= 60) {
          second = 0
          minute += 1
        }
        return { minute, second }
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [clock.running, isCountdown])

  const time = `${display.minute}:${display.second.toString().padStart(2, '0')}`

  return shouldShowPeriod ? `${periodShort(clock.period)} (${time})` : `${time}”`
}

// =============
// Local Helpers
// =============

function periodShort(period: string) {
  if (/quarter/i.test(period)) {
    const match = period.match(/(\d)(st|nd|rd|th)\s+Quarter/i)
    if (match) return `Q${match[1]}`
  }
  return period
}
